import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import { usePlayerHistoryListDesktop } from 'features/reports/hooks/useLists';

import './TableRow.scss';

const TableRow = ({ item, type = null, callback }) => {
  const b = block('table-row-pagination');
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const getList = useMemo(() => {
    switch (type) {
      case 'player-history':
        return usePlayerHistoryListDesktop;
      default:
        return () => Object.values({ ...item, transitionType: locale[item.transitionType] });
    }
  }, [item, type, locale]);

  const headers = Object.keys(item);

  const list = Object.values(getList(item));

  return (
    <div onClick={() => callback(item)} className={b('tr', { withPointer: Boolean(callback) })}>
      {list.map((el, index) => {
        const isHistory = headers[index] === 'status' || headers[index] === 'type';
        return (
          <div key={`${el}_${index}`} className={b('td', { status: isHistory && el })}>
            {isHistory ? locale.statuses[el] : el}
          </div>
        );
      })}
    </div>
  );
};

TableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default TableRow;
